import { ButtonLabelLayoutTheme, styles, variants } from '../ButtonLabelLayoutStyles.css';
import { baseTheme } from './ButtonLabelLayoutBaseTheme.css';
import { multiVariantStyles } from './ButtonLabelLayoutVariants.css';

/*******************
 * Component Theme
 *******************/

const ButtonLabelLayoutStableTheme: ButtonLabelLayoutTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { ButtonLabelLayoutStableTheme };
